export enum CategoryStatuses {
  InTranslation = 1,
  WaitingForTranslation = 2,
  ErrorWhenTranslating = 3,
  Translated = 4,
}
